export default __webpack_public_path__ + "static/media/mortgageone.531bf86f.svg";